import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-announcement mx-4 sm:mx-0 mb-6"
}
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true",
  class: "ml-1"
}

import { useRouter } from 'vue-router'
import { AnnouncementSection } from '@/global/state/StorefrontState'
import { openStorefrontLink } from '../storefrontUtils'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementSection',
  props: {
    section: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()

function onClick() {
  openStorefrontLink(router, props.section.settings.link)
}

return (_ctx: any,_cache: any) => {
  return (_ctx.section.settings.text)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.section.settings.link ? 'button' : 'div'), {
          type: "button",
          class: _normalizeClass(["sf-announcement__bar w-full text-center px-4 py-3 text-sm font-semibold", { 'cursor-pointer hover:opacity-90 transition-opacity': _ctx.section.settings.link }]),
          style: _normalizeStyle({
        backgroundColor: _ctx.section.settings.backgroundColor || 'var(--sf-primary)',
        color: _ctx.section.settings.textColor || '#ffffff'
      }),
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.section.settings.text) + " ", 1),
            (_ctx.section.settings.link)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "›"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "style"]))
      ]))
    : _createCommentVNode("", true)
}
}

})